import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import 'datatables.net';
import 'datatables.net-bs4';
import * as $ from 'jquery';
import { OWL_DATE_TIME_FORMATS } from 'ng-pick-datetime';
import { Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/take';
import { DialogHelper, ExceptionHelper } from '../../../../helper';
import { OWL_datetime_formats } from '../../owl_datetime_formats';
import { PMCreateDetail } from '../models/pm-create-detail.model';
import { createPMDetail, createPMEquipment } from '../reducers/pm-create.reducer';
import { PreventiveMaintenanceCreateService } from './preventive-maintenance-create.service';
import * as moment from 'moment';



@Component({
  selector: 'app-preventive-maintenance-create',
  templateUrl: './preventive-maintenance-create.component.html',
  styleUrls: ['./preventive-maintenance-create.component.css'],
  providers: [{provide: OWL_DATE_TIME_FORMATS, useValue: OWL_datetime_formats}],
  encapsulation: ViewEncapsulation.None

})
export class PreventiveMaintenanceCreateComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('dangerModal') dangerModal: any;
  id = '';
  pmDetailForm = this.fb.group({
    jobNumber: ['', [Validators.required]],
    isTandC: [0],
    tentativeBeginDate: ['', []],
    tentativeFinishDate: ['', []],
    pmServiceBeginDate: ['', []],
    pmServiceFinishDate: ['', []],
  });
  equipmentForm = this.fb.group({
    equipmentIds: ['']
  });
  currentStep = 0;
  jobs = [];
  selectedEquipments = [];
  equipmentList = [];
  dataTable: DataTables.Api;
  redirect = false;

  pmCreate: Observable<PMCreateDetail>;
  createTime = moment().set('hours', 0).set('minutes', 0).set('seconds', 0).toDate();
  d$ = new Subject();
  constructor(    private exception: ExceptionHelper, private router: Router,
    private dialog: DialogHelper,
    private fb: FormBuilder, private chRef: ChangeDetectorRef,private translate: TranslateService, private store: Store<PMCreateDetail>, private pmCreateService: PreventiveMaintenanceCreateService) {
    translate.setDefaultLang('en-us');
    this.pmCreate = store.take(1).pipe(select('pmCreate'));
   
    this.pmCreateService.getJobList({"job-completion":0}).subscribe(res => {
      this.jobs = res.jobListModel.map(r => {
        r.name = r.jobNumber;
        r.id = r.jobNumber;
        r.shortName = r.jobNumber;
        return r;
      });
    });
    

    
   }
   ngOnDestroy(): void {
    this.d$.next();
    this.d$.complete();
   }
  ngAfterViewInit(): void {      
  }

  
  ngOnInit() {
    this.pmDetailForm.updateValueAndValidity();

    this.pmDetailForm.get('jobNumber').valueChanges.subscribe(res => {     
      
      
      this.pmDetailForm.patchValue({
        isTandC: Number(this.jobs.find(j => j.id === res) && this.jobs.find(j => j.id === res).pmNum === 0)
      });      
      this.equipmentForm.get('equipmentIds').reset();
      this.selectedEquipments = [];
      
      this.pmCreateService.getActiveEquipmentList(this.pmDetailForm.get('jobNumber').value).subscribe(res => {     


        if ($.fn.dataTable.isDataTable('#ecallEquipmentDataTables')) {
          $('#ecallEquipmentDataTables').DataTable().destroy();
        }
  
        this.equipmentList = [...res.equipmentListModel];      
  
        this.chRef.detectChanges();
       
        const table: any = $('#ecallEquipmentDataTables');
        this.dataTable = table.DataTable();
        
        
      },
      error => {
        $('.card').hide();
        this.exception.showError(error, 'showDanModalBtn');
      });
    });

   
  }

  selectAll(event): void {
    

    if(event.target.checked) {
      this.selectedEquipments = this.equipmentList.map(e => e);
    } else {
      this.selectedEquipments = [];
    }
    this.equipmentForm.patchValue({
      equipmentIds: this.selectedEquipments.map(x => x.equipmentId)
    });
  }

  selectEquipment(event, index): void {
    if(event.target.checked) {
      this.selectedEquipments.push(this.equipmentList[index]);
    } else {
      this.selectedEquipments = this.selectedEquipments.filter(x => x.equipmentId !== this.equipmentList[index].equipmentId);
    }
    this.equipmentForm.patchValue({
      equipmentIds: this.selectedEquipments.map(x => x.equipmentId)
    });
  }

  isChecked(equipment): boolean {
    return this.selectedEquipments.findIndex(e => e.equipmentId === equipment.equipmentId) > -1;
  }
  onCustomerSelect(event): void {
    this.pmDetailForm.patchValue({
      jobNumber: event.id
    });
  }
  onCustomerDeselect(event): void {
    

  }
  onClose(event): void {
    

  }
  back(): void {
    this.currentStep--;
  }
  next(): void {
    if(this.currentStep === 0) {
      this.store.dispatch({type: createPMDetail, payload: this.pmDetailForm.value});      
    }
    this.currentStep++;
  }
  create(): void {
    this.store.dispatch({type: createPMEquipment, payload: this.equipmentForm.get('equipmentIds').value.map(x => {        
      return {
        equipmentId: x,
        isActive: 1
      }
    })});
    
    this.pmCreate.subscribe(state => {
      
      
      this.pmCreateService.createPM({
        jobNumber: state.jobNumber,
        isTandC: state.isTandC,
        type: 0,
        tentativeBeginDate: state.tentativeBeginDate ? moment(state.tentativeBeginDate).format('YYYY-MM-DD HH:mm:ss'): null,
        tentativeFinishDate: state.tentativeFinishDate ? moment(state.tentativeFinishDate).format('YYYY-MM-DD HH:mm:ss'): null,
        pmServiceBeginDate: state.pmServiceBeginDate ? moment(state.pmServiceBeginDate).format('YYYY-MM-DD HH:mm:ss'): null,
        pmServiceFinishDate: state.pmServiceFinishDate ? moment(state.pmServiceFinishDate).format('YYYY-MM-DD HH:mm:ss'): null,
        pmequipmentListModel: state.pmequipmentListModel

      }).subscribe(res => {
        this.id = res.pmIds[0];
        this.dialog.showModal('showSucModalBtn');

      }, err => {
        this.exception.showError(err, 'showDanModalBtn');
      });      
    });
  }

  dateTimeChange(ele: any, controlName: string) {
    
    const control = this.pmDetailForm.get(controlName);
    if(control !== undefined && ele.value) {
      control.setValue(moment(ele.value, 'YYYY-MM-DD HH:mm:ss').toDate());
    }
    if (controlName === 'tentativeBeginDate' || controlName === 'tentativeFinishDate') {
      this.pmDetailForm.patchValue({
        pmServiceBeginDate: '',
        pmServiceFinishDate: '',
      });     
    } else {
      this.pmDetailForm.patchValue({
        tentativeBeginDate: '',
        tentativeFinishDate: '',
      });
    }
  }

  selectTC(event: any) {
    this.pmDetailForm.patchValue({
      isTandC: Number(event.target.checked)
    });
  }


  closeSuccessModel() {
    this.router.navigate(['/home/preventive-maintenance/detail', this.id]);
  }

  errorClose() {
    if (this.redirect) {
      this.router.navigate(['/home/preventive-maintenance']);
    }
    else {
      this.dangerModal.hide();
    }
  }


 get tentativeBeginDate() { return this.pmDetailForm.get('tentativeBeginDate'); }
 get tentativeFinishDate() { return this.pmDetailForm.get('tentativeFinishDate'); }
 get pmServiceBeginDate() { return this.pmDetailForm.get('pmServiceBeginDate'); }
 get pmServiceFinishDate() { return this.pmDetailForm.get('pmServiceFinishDate'); }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/preventive-maintenance/preventive-maintenance-create/preventive-maintenance-create.component.ts